// © 2025 nSide, Inc. All Rights Reserved.
// This software and its source code are the confidential and proprietary
// information of nSide, Inc. (“Confidential Information”). You may not
// use, reproduce, disclose, distribute, modify, or create derivative works
// of this code except in accordance with a written license agreement or
// other written authorization from nSide, Inc.

// Unauthorized use is strictly prohibited and may result in civil and
// criminal penalties.



import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeUrl',
  standalone: true
})
export class SanitizeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
